{
  "Accessibility Menu": "Saavutettavuusvalikko",
  "Reset settings": "Palauta asetukset",
  "Close": "Sulje",
  "Content Adjustments": "Sisällön säädöt",
  "Adjust Font Size": "Säädä fonttikokoa",
  "Highlight Title": "Korosta otsikko",
  "Highlight Links": "Korosta linkit",
  "Readable Font": "Helposti luettava fontti",
  "Color Adjustments": "Värien säädöt",
  "Dark Contrast": "Tumma kontrasti",
  "Light Contrast": "Vaalea kontrasti",
  "High Contrast": "Korkea kontrasti",
  "High Saturation": "Korkea kylläisyys",
  "Low Saturation": "Matala kylläisyys",
  "Monochrome": "Yksivärinen",
  "Tools": "Työkalut",
  "Reading Guide": "Lukemisopas",
  "Stop Animations": "Pysäytä animaatiot",
  "Big Cursor": "Iso kohdistin",
  "Increase Font Size": "Suurenna fonttikokoa",
  "Decrease Font Size": "Pienennä fonttikokoa",
  "Letter Spacing": "Kirjainten välistys",
  "Line Height": "Rivin korkeus",
  "Font Weight": "Fontin paksuus",
  "Dyslexia Font": "Dysleksiafontti",
  "Language": "Kieli",
  "Open Accessibility Menu": "Avaa saavutettavuusvalikko"
}
